import { render, staticRenderFns } from "./PopupDialog.vue?vue&type=template&id=42087d4d&scoped=true&"
import script from "./PopupDialog.vue?vue&type=script&lang=js&"
export * from "./PopupDialog.vue?vue&type=script&lang=js&"
import style0 from "./PopupDialog.vue?vue&type=style&index=0&id=42087d4d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42087d4d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('42087d4d')) {
      api.createRecord('42087d4d', component.options)
    } else {
      api.reload('42087d4d', component.options)
    }
    module.hot.accept("./PopupDialog.vue?vue&type=template&id=42087d4d&scoped=true&", function () {
      api.rerender('42087d4d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2ssG4L5bpdwiN/JS/comp/PopupDialog.vue"
export default component.exports